<template>
  <div class="location_batches">
      <div class="avail_search">
        <pro-search 
        :fileds="SearchFiled"
        :form="queryForm"
        @search="handleSearch"
        @reset="handleReset"
        >
        <template #warehouseCode >
          <!-- <cascaderSelect v-if="isEnterprise" @change="handleWhChange"></cascaderSelect> -->
          <select-dom v-if="!isNowWaCustomer" v-model="queryForm.shipperId" :is-every-request="false" :list="ProjectList" @onSearch="onSearchProject" @checkedList="checkedList" />
          <wareHouse-select  v-else :select-ware="queryForm.warehouseCodeCustomers" :option="ProjectList" @change="handleChange" />
        </template>
        <template  #warehouseAreaId>
          <a-select
            v-model="queryForm.warehouseAreaId"
            show-search
            :allow-clear="true"
            placeholder="请选择库区"
            option-filter-prop="children"
            :filter-option="filterOption"
            @change="getData()"
          >
            <a-select-option v-for="option in warehouseZonelist" :key="option.id" :value="option.id">
            {{option.zoneName}}
            </a-select-option>
          </a-select>
        </template>
         <template  #labelSelect>
            <select-label
              :label-select-data="labelSelectData"
              :label-options="attributeCodes"
              @update:labelSelectData="handleUpdate"
            />
        </template>
      </pro-search>
      </div>
      <div class="avail_table">
        <div class="operate_bar">
          <a-button class="btn_export" @click="handleExport">导出</a-button>
        </div>
        <a-table
        :loading="tableLoading"
        :columns="tableCol"
        :data-source="goodsData"
        class="table-sigle"
        row-key="id"
        :scroll="{ x: 'calc(700px + 50%)'}"
        :pagination="pagination"
         :row-selection="{
          onSelect: handleRowSelect,
          onSelectAll: handleRowSelectAll,
          onChange,
          selectedRowKeys: selectedRowKeys
        }"
        @change="handleTableChange"
        > 
          <template #warnStatusDesc="text,row">
            <span>
              <span 
              class="status-flag"
              :style="{backgroundColor: ALERT_ENUM[row.warnStatus]}"/>
                {{text}}
            </span>
          </template>
           <template #action="text,row">
            <a-button v-track-click="{ trackName: '数据分析-库存管理-库存查询-按库位批次库存明细-预占记录' }" type="link" @click="handleRecordsClick(row)">
              预占记录
            </a-button>
          </template>
          <template slot="goodsName" slot-scope="text">
            <a-tooltip>
              <template slot="title">{{text}}</template>
              <p class="overlength"> {{text}}</p>
            </a-tooltip>
          </template>
        </a-table>
      </div>
    <recordsDialog ref="recordsDialog" />
  </div>  
</template>

<script>
import SelectDom from '@/components/select/SelectDom'
import { EventBus } from '@/utils/event-bus'
// import cascaderSelect from '@/components/cascaderSelect/index.vue'
import ProSearch from '@/components/TableSearch/index.vue'
import { getWareHouse } from '../../../../warehouseOrder/api'
import {locationBatchesTableColumns,locationBatchesSearchFiled,ALERT_ENUM} from '../constant'
import {
  warehouseZonePage,
  getDictionaryFromWms,
  batchFieldList,
  // customerShowList,
  warehouseStockBatchPage,
  warehouseStockBatchExport
} from '../../api'
import selectLabel from './selectLabel.vue'
import recordsDialog from './recordsDialog.vue'
import wareHouseSelect from '../../component/warehouseSelect.vue'

const ATTRIBUTE_TYPE = {
  INPUT: 'input',
  DATE: 'date',
};
export const SearchType = {
  INPUT: 'input',
  SELECT: 'select',
  CASCADER: 'cascader',
  DATE_PICKER: 'date-picker',
};
  export default {
    name:'LocationBatches',
    components:{
      SelectDom,
      ProSearch,
      selectLabel,
      recordsDialog,
      wareHouseSelect
    },
    props:{
      isNowWaCustomer:{
        type:Boolean,
        default:()=>false
      }
    },
    data(){
      return {
        queryForm:{},
        ProjectList: [],
        ALERT_ENUM,
        locationBatchesTableColumns,
        goodsData: [],
        pagination: {
          current: 1,
          total: 0,
          pageSize:10,
          defaultPageSize: 10,
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '30', '40', '50'],
          onShowSizeChange: (current, pageSize) => {
            this.pagination.pageSize = pageSize
          },
          showQuickJumper: true,
          showTotal: total => `共 ${total} 条`
        },
        warehouseZonelist:[], // 库区列表
        ZONE_TEMPERATURE_LAYER_CODE:[], // 温区选项
        GOODS_QUALITY:[], // 质量选项
        attributeCodes:[], 
        labelSelectData: {
          labelKey: '',
          labelValue: '',
        },
        selectedOrders: [],
        selectedRowKeys: [],
        batchField: [],
        tableLoading:false
      }
    },
    computed:{
      SearchFiled(){
        return locationBatchesSearchFiled(this.GOODS_QUALITY,this.ZONE_TEMPERATURE_LAYER_CODE)
      },
      tableCol() {
        return locationBatchesTableColumns();
      },
    },
    watch:{
      'labelSelectData.labelValue':function(){
        this.getData();
      },
    },
   async created() {
      // await this.getWareHouse()
      // await this.getWarehouseZonelist()
      // this.getDictionaryFrom()
      // this.loadBatchFieldList();
      // this.getBatchField();
    },
    methods:{
      // async getBatchField() {
      //   this.batchField = await customerShowList();
      // },
      async init(){
        await this.getWareHouse()
        await this.getWarehouseZonelist()
        this.getDictionaryFrom()
        this.loadBatchFieldList();
      },
      async getDictionaryFrom(){
        const res=await getDictionaryFromWms()
        this.GOODS_QUALITY= this.setDictionaryFormat(res,"GOODS_QUALITY")
        this.ZONE_TEMPERATURE_LAYER_CODE= this.setDictionaryFormat(res,"ZONE_TEMPERATURE_LAYER_CODE")
      },
      setDictionaryFormat(data,code){
        const list = data.find(item=>item.dictionaryCode===code).dictionaryValues
        return list.map((item) => ({
          value: item.code,
          label: item.name,
        }))
      },
      async getWarehouseZonelist(word) {
        const data={
          warehouseCodes:[this.queryForm.warehouseCode],
          zoneName: word || ''
        }
        if(this.isNowWaCustomer){
          const res =this.ProjectList.map(item=>item.tenantId)
          data.warehouseCodes=this.queryForm.warehouseCodes&&this.queryForm.warehouseCodes.length?this.queryForm.warehouseCodes:res
        }
        const resp = await warehouseZonePage({ page: 1, size: 1000 },data);
        this.warehouseZonelist = resp.records;
      },
      async loadBatchFieldList() {
        let result = await batchFieldList({});
        result = result || [];
        this.attributeCodes = result.map((item) => ({
          ...item,
          label: item.fieldName,
          value: item.fieldCode,
          type: item.component === ATTRIBUTE_TYPE.DATE
            ? SearchType.DATE_PICKER : SearchType.INPUT,
          props: {
            clearable: true,
          },
        }));
        this.labelSelectData.labelKey = this.attributeCodes[0].value;
      },
      handleSearch(form){
        this.pagination.current=1
        this.queryForm={
          ...form,
        }
        this.getData();
      },
      handleWhChange(data){
        this.queryForm.warehouseCode =data.tenantId
        this.queryForm.shipperId =data.customerId
        this.ProjectList=[data]
        this.getData(true)
      },
     async handleExport(){
      const {warehouseCodes,customerIds,warehouseCode,shipperId,warehouseCodeCustomers,...restParams}=this.queryForm;
      if(!this.isNowWaCustomer&&!shipperId){
        this.$message.warning('未选择仓库,无法查询数据')
        return
      }
      const data = {
         ...restParams,
        batchAttrName: this.labelSelectData.labelKey,
        batchAttrValue: this.labelSelectData.labelValue,
      }
      if(this.isNowWaCustomer){
        data.warehouseCodes=warehouseCodes;
        data.customerIds=customerIds;
      }else{
        data.warehouseCode=warehouseCode;
        data.customerIds=[shipperId];
      }
      if (this.selectedRowKeys.length > 0) {
        data.selectIds = this.selectedRowKeys;
      }
       await warehouseStockBatchExport(data)
       EventBus.$emit('taskPopover')
      },
      checkedList(data){
        this.queryForm.shipperId = data.customerId;
        this.queryForm.warehouseCode = data.tenantId;
        this.getData(true)
        this.getWarehouseZonelist()
      },
      handleReset(){
        this.pagination.current=1
        this.queryForm={}
        this.queryForm={
          warehouseCode: this.ProjectList[0].tenantId,
          shipperId: this.ProjectList[0].customerId,
        }
        this.getData();
      },
    onSearchProject(tenantName){
      this.getWareHouse(tenantName)
    },
    async getData(current = null){
      if(current){
        this.pagination.current = 1
      }
       this.tableLoading=true
      const {warehouseCodes,customerIds,warehouseCode,shipperId,warehouseCodeCustomers,...restParams}=this.queryForm;
      if(!this.isNowWaCustomer&&!shipperId){
        this.$message.warning('未选择仓库,无法查询数据')
        this.tableLoading=false;
        return
      }
      const data ={
        ...restParams,
        batchAttrName: this.labelSelectData.labelKey,
        batchAttrValue: this.labelSelectData.labelValue,
      }
      if(this.isNowWaCustomer){
        data.warehouseCodes=warehouseCodes;
        data.customerIds=customerIds;
      }else{
        data.warehouseCode=warehouseCode;
        data.customerIds=[shipperId];
      }
      const params = {
        size: this.pagination.pageSize,
        page: this.pagination.current
      }
      try {
        const res= await warehouseStockBatchPage(data, params)
        this.goodsData = res.records
        this.pagination.total = res.total
        this.tableLoading=false
      } catch (error) {
        this.goodsData =[]
        this.pagination.total = 0
        this.tableLoading=false
      }
    },
     handleTableChange(pagination) {
      this.pagination = {
        ...this.pagination,
        current: pagination.current
      }
      this.getData();
    },
    async getWareHouse(tenantName=null){
      const data = {
          customerCodes: [this.$store.state.user.customerCode],
          needExcludeDefaultTenant: true,
          tenantName,
          isReadConfig:true,
      }
      if(this.isNowWaCustomer){
        data.isReadConfig=true
        data.type='DELIVER'
      }
      const res = await getWareHouse(data,{size:500})
        if(res.records.length <= 0){
          this.ProjectList = []
          this.$message.warning('未选择仓库,无法查询数据')
          return
        }
        const arr = res.records.map((e) => {
            if(!this.isNowWaCustomer){
            return {
                ...e,
                label: e.tenantName,
                formatLabel: `${e.tenantName} (${e.shipperName})`,
                value: e.customerId
            }
          }
            return {
                ...e,
                label: e.tenantName,
                formatLabel: `${e.tenantName} (${e.shipperName})`,
                value: e.customerId
            }
        })
        this.ProjectList = arr
        if(this.goodsData.length <= 0){
          if(arr.length > 0 && !this.queryForm.shipperId ){
            if(!this.isNowWaCustomer){
              this.queryForm.warehouseCode = arr[0].tenantId;
              this.queryForm.shipperId = arr[0].customerId;
            }
          }
          this.getData()
        }
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    handleRowSelect(record, selected, selectedRows) {
      this.selectedOrders = selectedRows
    },
    handleRowSelectAll (selected, selectedRows) {
      this.selectedOrders = selectedRows
    },
    onChange(selectedRowKeys){
      this.selectedRowKeys = selectedRowKeys
    },
    handleRecordsClick(row){
      this.$refs.recordsDialog.open(row)
    },
    handleChange(value){
      this.queryForm.customerIds=[];
      this.queryForm.warehouseCodes = [];
      this.ProjectList.forEach(item=>{
        if(value.includes(item.value)){
          this.queryForm.customerIds.push(item.customerId)
          this.queryForm.warehouseCodes.push(item.tenantId)
        }
      })
      this.getData()
      this.getWarehouseZonelist()
    },
    handleUpdate(){
      this.labelSelectData.labelValue=''
    }
  }
}
</script>

<style lang="less" scoped>
.location_batches {
    background-color: #fff;
    border-radius: 6px;
    padding: 24px;
}
 .avail_search {
    margin-bottom: 12px;
  }
  .avail_table {
    // background-color: #fff;
    // border-radius: 6px;
    border-top: 1px solid #E7E9EC;
    padding-top: 24px;
  }
  .avail_form {
    /deep/.ant-form-item {
      width: 100%;
      .ant-form-item-label {
        width: 80px;
      }
      .ant-form-item-control-wrapper {
        width: calc(100% - 80px);
      }
    }
    .ant-col-6 {
      padding-right: 20px;
    }
    .form-btns {
      text-align: center;
      .form-btn {
        margin-left: 20px;
      }
    }
  }
  .operate_bar {
    margin-bottom: 24px;
    .btn_export {
      border: 1px solid #06B880;
      color: #06B880;
    }
  }
   .avail_form {
    /deep/.ant-form-item-label label {
      color: #606266;
    }
    /deep/ .ant-form-item-control-wrapper input {
      color: #171717 !important;
    }

  }
  .search_btn {
    color: #06B880;
    border-color: #06B880;
  }
  .overlength {
    overflow:hidden;
    text-overflow:ellipsis;
    display:-webkit-box;
    -webkit-box-orient:vertical;
    -webkit-line-clamp:2;
  }
  .status-flag {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
}
</style>